export const huboInfo = [
  {
    NUM: '1',
    HUBOID: '100138381',
    GIHO: '1',
    JD_NAME: '더불어민주당',
    NAME: '이재명',
    HANJA_NAME: '李在明',
    GENDER: '남',
    BIRTHDAY: '19641222',
    AGE: '57',
    ADDR: '경기도 성남시 분당구 수내로',
    JOB: '정당인',
    EDU: '중앙대학교 법학과 졸업',
    CAREER1: '(전) 경기도지사',
    CAREER2: '(전) 성남시장',
    STATUS: '등록',
  },
  {
    NUM: '2',
    HUBOID: '100138362',
    GIHO: '2',
    JD_NAME: '국민의힘',
    NAME: '윤석열',
    HANJA_NAME: '尹錫悅',
    GENDER: '남',
    BIRTHDAY: '19601218',
    AGE: '61',
    ADDR: '서울특별시 서초구 서초중앙로',
    JOB: '정치인',
    EDU: '서울대학교 대학원 졸업(법학석사)',
    CAREER1: '(전) 제43대 검찰총장',
    CAREER2: '(전) 서울중앙지방검찰청 검사장',
    STATUS: '등록',
  },
  {
    NUM: '3',
    HUBOID: '100138383',
    GIHO: '3',
    JD_NAME: '정의당',
    NAME: '심상정',
    HANJA_NAME: '沈相奵',
    GENDER: '여',
    BIRTHDAY: '19590220',
    AGE: '63',
    ADDR: '경기도 고양시 덕양구 신원로',
    JOB: '국회의원',
    EDU: '서울대학교 사범대학 사회교육학과 졸업',
    CAREER1: '(전) 정의당 대표',
    CAREER2: '(현) 국회의원',
    STATUS: '등록',
  },
  {
    NUM: '5',
    HUBOID: '100138395',
    GIHO: '5',
    JD_NAME: '기본소득당',
    NAME: '오준호',
    HANJA_NAME: '吳準鎬',
    GENDER: '남',
    BIRTHDAY: '19750620',
    AGE: '46',
    ADDR: '경기도 안산시 상록구 식물원로1안길',
    JOB: '작가',
    EDU: '서울대학교 인문대학 국어국문학과 졸업',
    CAREER1: '(현) 기본소득한국네트워크 운영위원',
    CAREER2: '(전) 기본소득당 용혜인 국회의원 비서관',
    STATUS: '등록',
  },
  {
    NUM: '6',
    HUBOID: '100138378',
    GIHO: '6',
    JD_NAME: '국가혁명당',
    NAME: '허경영',
    HANJA_NAME: '許京寧',
    GENDER: '남',
    BIRTHDAY: '19470713',
    AGE: '74',
    ADDR: '경기도 양주시 장흥면 권율로309번길',
    JOB: '강연업',
    EDU: '한국방송통신대학교 법학과 졸업',
    CAREER1: '(전) 제15대, 제17대 대통령선거 후보',
    CAREER2: '(현) 국가혁명당 명예대표',
    STATUS: '등록',
  },
  {
    NUM: '7',
    HUBOID: '100138411',
    GIHO: '7',
    JD_NAME: '노동당',
    NAME: '이백윤',
    HANJA_NAME: '李百允',
    GENDER: '남',
    BIRTHDAY: '19770525',
    AGE: '44',
    ADDR: '충청남도 서산시 안견로',
    JOB: '노동자',
    EDU: '미기재',
    CAREER1: '(전) 금속노조 동희오토사내하청지회장',
    CAREER2: '(현) 산업폐기물매립장감시서산시민단체연대 공동대표',
    STATUS: '등록',
  },
  {
    NUM: '8',
    HUBOID: '100138489',
    GIHO: '8',
    JD_NAME: '새누리당',
    NAME: '옥은호',
    HANJA_NAME: '玉恩鎬',
    GENDER: '남',
    BIRTHDAY: '19710710',
    AGE: '50',
    ADDR: '경기도 의왕시 원골로',
    JOB: '(주)아빅스 대표',
    EDU: '서울대학교 대학원 졸업(교육학석사)',
    CAREER1: '(현) (주)아빅스 대표',
    CAREER2: '(전) 클린선거시민행동 공동대표',
    STATUS: '등록',
  },
  {
    NUM: '10',
    HUBOID: '100138380',
    GIHO: '10',
    JD_NAME: '신자유민주연합',
    NAME: '김경재',
    HANJA_NAME: '金景梓',
    GENDER: '남',
    BIRTHDAY: '19421103',
    AGE: '79',
    ADDR: '서울특별시 영등포구 국제금융로',
    JOB: '정당인',
    EDU: '서울대학교 문리과대학 정치학과 졸업',
    CAREER1: '(전) 제15대, 16대 국회의원',
    CAREER2: '(전) 제16대 한국자유총연맹 총재',
    STATUS: '등록',
  },
  {
    NUM: '11',
    HUBOID: '100138379',
    GIHO: '11',
    JD_NAME: '우리공화당',
    NAME: '조원진',
    HANJA_NAME: '趙源震',
    GENDER: '남',
    BIRTHDAY: '19590107',
    AGE: '63',
    ADDR: '대구광역시 달서구 장기로',
    JOB: '정당인',
    EDU: '영남대학교 행정대학원 졸업(행정학 석사)',
    CAREER1: '(현) 우리공화당 당대표',
    CAREER2: '(전) 제18·19·20대 국회의원(대구달서구병)',
    STATUS: '등록',
  },
  {
    NUM: '12',
    JD_NAME: '진보당',
    GIHO: '12',
    NAME: '김재연',
    HANJA_NAME: '金在姸',
    GENDER: '여',
    BIRTHDAY: '19801030',
    AGE: '41',
    ADDR: '경기도 의정부시 민락로',
    JOB: '정당인',
    EDU: '한국외국어대학교 노어과 졸업',
    CAREER1: '(전) 19대 국회의원',
    CAREER2: '(현) 진보당 대표',
    STATUS: '등록',
  },
  {
    NUM: '13',
    HUBOID: '100138531',
    GIHO: '13',
    JD_NAME: '통일한국당',
    NAME: '이경희',
    HANJA_NAME: '李京熹',
    GENDER: '남',
    BIRTHDAY: '19740120',
    AGE: '48',
    ADDR: '서울특별시 강남구 선릉로',
    JOB: '통일한국당 대표',
    EDU: '한국외국어대학교 대학원 졸업(법학박사)',
    CAREER1: '(전) 2002년 서울시장 후보',
    CAREER2: '(전) 2017년 대통령 후보',
    STATUS: '등록',
  },
  {
    NUM: '14',
    HUBOID: '100138402',
    GIHO: '14',
    JD_NAME: '한류연합당',
    NAME: '김민찬',
    HANJA_NAME: '金旻澯',
    GENDER: '남',
    BIRTHDAY: '19580204',
    AGE: '64',
    ADDR: '서울특별시 동대문구 고산자로56길',
    JOB: '한류연합당 당대표',
    EDU: '원광디지털대학교 자연건강학과 졸업(이학석사)',
    CAREER1: '(현) 월드마스터위원회 위원장',
    CAREER2: '(전) 제19대 대통령선거 후보',
    STATUS: '등록',
  },
];
